import {
  getOrderListData,
  getOrderDataById,
  getOrderOverviewData,
} from '../orders/mockData'
import { _storeEntityDataListToLocalForage } from '../../modules/mockDataStorageManager'
import {
  getTeamMemberListData,
  _getTMDataById,
  //   _getTMSelectItemDataById,
} from '../teamMembers/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { IOrderServiceOrder } from '~/types/order/models'
import { assertIsNotUndefined } from '~/types/models'
import {
  OrderMSServicesStatusIds,
  getOrderMSServiceStatusById,
} from '~/services/selectLists/orderMSServicesStatii'
import { propagateOrderServiceOrderData } from '~/cynqueModules/dataObjects/OrderServiceOrder'

// import {
//   getProjectListData,
//   _getProjSelectItemDataById,
// } from '../projects/mockData'
// import {
//   getLocationListData,
//   _getLSelectItemDataById,
// } from '../locations/mockData'
// import {
//   getSupplierListData,
//   _getSSelectItemDataById,
// } from '../suppliers/mockData'
// import {
//   getSupplierContactListData,
//   _getSCTDataById,
// } from './../supplierContacts/mockData'
// import { getTsdListData, _getTSelectItemDataById } from '../tsds/mockData'
// import { getTsdContactListData, _getTCTDataById } from '../tsdContacts/mockData'
// import {
//   getOpportunityListData,
//   _getOSelectItemDataById,
// } from '../opportunities/mockData'
// import {
//   getMasterOrderServiceOrderListData,
//   _getMOSelectItemDataById,
// } from '../orders/mockData'
// import {
//   getOrderServiceOrderStatusById,
//   OrderStatusIds,
// } from '~/services/selectLists/orderStatii'
// import {
//   getCompanyContactListData,
//   _getCCTDataById,
// } from '../companyContacts/mockData'
// import { getPriorityById, PriorityIds } from '~/services/selectLists/priorities'
import {
  getOrderServiceOrderStatusById,
  OrderServiceOrderStatusIds,
} from '~/services/selectLists/orderServiceOrderStatii'

const mn = `[api/msw/api/orderServiceOrders/mockData.ts]`

const orderListData = undefined as unknown as IOrderServiceOrder[]

export const getOrderServiceOrderListData = getListDataFunctionFactory<
  IOrderServiceOrder[]
>({
  listData: orderListData,
  storageKey: 'orderserviceorders',
  getStartingListData: getStartingOrderServiceOrderListData,
  // sortFunction: (a, b) => {
  //   if (b.createdAt > a.createdAt) {
  //     return -1
  //   }
  //   if (b.createdAt < a.createdAt) {
  //     return 1
  //   }
  //   return 0
  // },
})

export async function getOrderServiceOrderDataById(
  id: TEntityId
): Promise<IOrderServiceOrder | undefined> {
  const list = await getOrderServiceOrderListData()
  if (!list) {
    throw new Error(`serviceOrderList returned undefined/null`)
  }
  return list.find((momso: IOrderServiceOrder) => momso.id === id)
}

export async function getOrderServiceOrderListDataByOrderId(
  id: TEntityId
): Promise<IOrderServiceOrder[]> {
  const list = await getOrderServiceOrderListData()
  if (!list) {
    throw new Error(`serviceOrderList returned undefined/null`)
  }
  return (
    list.filter(
      (ordso: IOrderServiceOrder) => ordso.order && ordso.order.id === id
    ) ?? []
  )
}

// export async function getOrderServiceOrderListDataByCompanyId(
//   id: TEntityId
// ): Promise<IOrderServiceOrder[]> {
//   const list = await getOrderServiceOrderListData()
//   if (!list) {
//     throw new Error(`serviceOrderList returned undefined/null`)
//   }
//   return (
//     list.filter(
//       (order: IOrderServiceOrder) =>
//         order.company?.id === id || order.contact?.company?.id === id
//     ) ?? []
//   )
// }

// export async function getOrderServiceOrderListDataByOpportunityId(
//   id: TEntityId
// ): Promise<IOrderServiceOrder[]> {
//   const list = await getOrderServiceOrderListData()
//   if (!list) {
//     throw new Error(`orderList returned undefined/null`)
//   }
//   return (
//     list.filter(
//       (order: IOrderServiceOrder) =>
//         order.opportunities &&
//         order.opportunities.find((opportunity) => opportunity.id === id)
//     ) ?? []
//   )
// }

// export async function getOrderServiceOrderListDataByOrderId(
//   id: TEntityId
// ): Promise<IOrderServiceOrder[]> {
//   const list = await getOrderServiceOrderListData()
//   if (!list) {
//     throw new Error(`orderList returned undefined/null`)
//   }
//   return (
//     list.filter(
//       (order: IOrderServiceOrder) => order.order && order.order.id === id
//     ) ?? []
//   )
// }

// export async function getOrderServiceOrderListDataByProjectId(
//   id: TEntityId
// ): Promise<IOrderServiceOrder[]> {
//   const list = await getOrderServiceOrderListData()
//   if (!list) {
//     throw new Error(`orderList returned undefined/null`)
//   }
//   return (
//     list.filter((order: IOrderServiceOrder) => order.project && order.project.id === id) ??
//     []
//   )
// }

// export async function getOrderServiceOrderListDataByLocationId(
//   id: TEntityId
// ): Promise<IOrderServiceOrder[]> {
//   const list = await getOrderServiceOrderListData()
//   if (!list) {
//     throw new Error(`orderList returned undefined/null`)
//   }
//   return (
//     list.filter(
//       (order: IOrderServiceOrder) => order.location && order.location.id === id
//     ) ?? []
//   )
// }

export async function getOrderServiceOrderListDataByTenantProductionManagerId(
  id: TEntityId
): Promise<IOrderServiceOrder[]> {
  const list = await getOrderServiceOrderListData()
  if (!list) {
    throw new Error(`orderServiceOrderList returned undefined/null`)
  }
  const orderServiceOrders =
    list.filter(
      (e: IOrderServiceOrder) =>
        e.tenantProductionManager && e.tenantProductionManager.id === id
    ) ?? []
  return orderServiceOrders
}

// export async function getOrderServiceOrderListDataBySupplierId(
//   id: TEntityId
// ): Promise<IOrderServiceOrder[]> {
//   const list = await getOrderServiceOrderListData()
//   if (!list) {
//     throw new Error(`orderList returned undefined/null`)
//   }
//   const orders =
//     list.filter(
//       (e: IOrderServiceOrder) => e.supplier?.id === id || e.contact?.supplier?.id === id
//     ) ?? []
//   return orders
// }

// export async function getOrderServiceOrderListDataByTsdId(
//   id: TEntityId
// ): Promise<IOrderServiceOrder[]> {
//   const list = await getOrderServiceOrderListData()
//   if (!list) {
//     throw new Error(`orderList returned undefined/null`)
//   }
//   const orders =
//     list.filter((e: IOrderServiceOrder) => e.tsd?.id === id || e.contact?.tsd?.id === id) ??
//     []
//   return orders
// }

// export async function getOrderServiceOrderListDataByTeamMemberId(
//   id: TEntityId
// ): Promise<IOrderServiceOrder[]> {
//   const list = await getOrderServiceOrderListData()
//   if (!list) {
//     throw new Error(`orderList returned undefined/null`)
//   }
//   const orders =
//     list.filter((e: IOrderServiceOrder) => e.owner?.id === id || e.assignedTo?.id === id) ??
//     []
//   return orders
// }

//
// Propagation Methods
//

export async function propagateOrderServiceOrderAdditions({
  newEntityData,
}: {
  newEntityData: IOrderServiceOrder
}) {
  const fn = `${mn} propagateOrderServiceOrderAdditions |`
  if (!newEntityData) {
    console.debug(`${fn} newEntityData is falsey. Nothing to propagate.`)
    return
  }
  _propagateOrderServiceOrderAdditionsChangesOrDeletions({
    orderServiceOrder: newEntityData,
  })
}

export async function propagateOrderServiceOrderChanges({
  targetItem,
}: {
  targetItem: IOrderServiceOrder
}) {
  const fn = `${mn} propagateOrderServiceOrderChanges |`
  if (!targetItem) {
    console.debug(`${fn} updatedEntityData is falsey. Nothing to propagate.`)
    return
  }
  _propagateOrderServiceOrderAdditionsChangesOrDeletions({
    orderServiceOrder: targetItem,
  })
}

export async function propagateOrderServiceOrderDeletions({
  deletedEntityData,
}: {
  deletedEntityData: IOrderServiceOrder
}) {
  const fn = `${mn} propagateOrderServiceOrderDeletions |`
  if (!deletedEntityData) {
    console.debug(`${fn} deletedEntityData is falsey. Nothing to propagate.`)
    return
  }
  _propagateOrderServiceOrderAdditionsChangesOrDeletions({
    orderServiceOrder: deletedEntityData,
  })
}

async function _propagateOrderServiceOrderAdditionsChangesOrDeletions({
  orderServiceOrder,
}: {
  orderServiceOrder: IOrderServiceOrder
}) {
  const fn = `${mn} _propagateOrderServiceOrderAdditionsChangesOrDeletions |`
  console.debug(`${fn} running`)
  if (!orderServiceOrder) {
    console.debug(`${fn} orderServiceOrder is falsey. Nothing to propagate.`)
    return
  }
  const order = await getOrderDataById(orderServiceOrder.order.id)
  if (!order) {
    throw new Error(`getOrderDataById returned undefined/null`)
  }
  const overviewData = await getOrderOverviewData(order.id)
  assertIsNotUndefined(overviewData)
  console.debug(`${fn} overviewData:`, overviewData)

  propagateOrderServiceOrderData({
    callingFn: fn,
    overviewData,
  })
  console.debug(`${fn} order after propagation:`, overviewData.order)

  const orderList = await getOrderListData()
  if (!orderList) {
    throw new Error(`getOrderListData returned undefined/null`)
  }
  await _storeEntityDataListToLocalForage({
    entityKeyBase: 'orders',
    listData: orderList,
    callingFn: fn,
  })
}
//
//
//

export async function getStartingOrderServiceOrderListData(): Promise<
  IOrderServiceOrder[]
> {
  // const tmList = await getTeamMemberListData()
  // const projList = await getProjectListData()
  // const cctList = await getCompanyContactListData()
  // const sctList = await getSupplierContactListData()
  // const locList = await getLocationListData()
  // const sList = await getSupplierListData()
  // const tList = await getTsdListData()
  // const tctList = await getTsdContactListData()
  // const oList = await getOpportunityListData()
  // const moList = await getOrderListData()

  return [
    {
      id: 'XXORDSO0001',
      hrid: 'ORDSO0001',
      descr: 'Cogent SO 1',
      order: { id: 'XXORD0001', label: 'DIA - Target & Big Mac' },
      orderType: [{ id: 1, label: 'New' }],
      supplier: { id: 'XXS0002', label: 'Cogent' },
      supplierOrderNum: 'CSO11111',
      doExpedite: false,
      expediteFeeAmount: 0,
      status: getOrderServiceOrderStatusById(
        OrderServiceOrderStatusIds.ACCEPTED
      ),
      enteredBy: _getTMDataById('XXTM0001', await getTeamMemberListData()),
      momssStatusCounts: [
        {
          status: getOrderMSServiceStatusById(
            OrderMSServicesStatusIds.ACCEPTED
          ),
          count: 4,
        },
      ],
      createdAt: '2025-08-21T00:08:49.556Z',
      modifiedAt: '2025-08-21T00:08:49.556Z',
      canBeDeleted: false,
      version: '1',
    },
  ]
}
